import styles from "./NewMatchesNotice.module.css";

interface NewMatchesNoticeProps {
  count: number;
  visible: boolean;
  onShow: () => void;
}

export function NewMatchesNotice({ count, visible, onShow }: NewMatchesNoticeProps) {
  if (!visible || count <= 0) return null;

  return (
    <button className={styles.button} type="button" onClick={onShow}>
      {count} new match{count === 1 ? "" : "es"}
    </button>
  );
}
